export function schoolSharedLinkFindAll() {
  const query = `{
            schoolSharedLinkFindAll {
              id,
              description,
             link,
              icon
            }
        }`;
  return query;
}

export function schoolSharedLinkSaveMutation(values) {
  const mutationQuery = `mutation{
        schoolSharedLinkSave( schoolSharedLink:
                {   
                    id: 0,                 
                    description: "${
                      values.description ? values.description : null
                    }",
                    link: "${values.link ? values.link : null}"
                    icon: null
                },
       )
        {id}
    }`;
  return mutationQuery;
}

export function schoolSharedLinkIdMutation(id) {
  const query = `mutation {schoolSharedLinkDelete(schoolSharedLinkId: ${id})}`;
  return query;
}
